import React, { useState, useRef  } from 'react';
import Divider from './divider';
import '../App.css';


function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}


const AverageAgentCommission = () => {
  const [averageAgentSales, setAverageAgentSales] = useState(100);
  const [level1Agents, setLevel1Agents] = useState(3);
  const [level2Agents, setLevel2Agents] = useState(0);
  const [level3Agents, setLevel3Agents] = useState(0);
  const [level4Agents, setLevel4Agents] = useState(0);
  const [level5Agents, setLevel5Agents] = useState(0);
  const [level6Agents, setLevel6Agents] = useState(0);
  const [transactionQty, setTransactionQty] = useState(0);
  const [feeMonthly, setFeeMonthly] = useState(0);
  const [feeTransaction, setFeeTransaction] = useState(0);
  const [salePrice, setSalePrice] = useState(0);
  const [compCap, setCompCap] = useState(0);
  const [transactionComp, setTransactionComp] = useState(3);
  const [agentCompThem, setAgentCompThem] = useState(80);
  const [currentTab, setCurrentTab] = useState(null);
  const [highestTab, setHighestTab] = useState(5);
  
  // Calculator Left Right Arrows for Recruit Tab
  const [scrollPosition, setScrollPosition] = useState(0);
  const scrollableContainerRef = useRef();

  const level1Anual = level1Agents * (averageAgentSales * 30);
  const level1Monthly = level1Anual / 12;

  const level2Anual = level1Agents >= 3 ? level2Agents * (averageAgentSales * 30) : 0;
  const level2Monthly = level2Anual / 12;

  const level3Anual = level1Agents >= 5 ? level3Agents * (averageAgentSales * 22.5) : 0;
  const level3Monthly = level3Anual / 12;

  const level4Anual = level1Agents >= 10 ? level4Agents * (averageAgentSales * 22.5) : 0;
  const level4Monthly = level4Anual / 12;

  const level5Anual = level1Agents >= 15 ? level5Agents * (averageAgentSales * 22.5) : 0;
  const level5Monthly = level5Anual / 12;

  const level6Anual = level1Agents >= 20 ? level6Agents * (averageAgentSales * 22.5) : 0;
  const level6Monthly = level6Anual / 12;

  const totalAnual = level1Anual + level2Anual + level3Anual + level4Anual + level5Anual + level6Anual;
  const totalMonthly = totalAnual / 12;

  const grossCommission = ((salePrice * (transactionComp / 100)) * transactionQty);
  const grossCommissionDesertNorth = ((salePrice * (3 / 100)) * transactionQty);

  const lessProfitShare = Math.min(grossCommissionDesertNorth * 0.2, 15000);
  const plusPassiveIncome = totalAnual;
  const commissionToAgentDesertNorth = grossCommission - lessProfitShare + plusPassiveIncome;
  const personalCommissionToAgentDesertNorth = grossCommission - lessProfitShare;

  
  const companyDollars = compCap > 0
     ? Math.min(grossCommission * ((100 - agentCompThem)/100), compCap)
     : 0;
 

  const feesPaidToCompany = agentCompThem < 100
    ? (feeTransaction * transactionQty) + (feeMonthly * 12) - companyDollars + ((salePrice * (transactionComp / 100)) * transactionQty) * ((100 - agentCompThem)/100)
    : (feeTransaction * transactionQty) + (feeMonthly * 12) - companyDollars;

  const commissionToAgent = grossCommission - feesPaidToCompany;
  const effectiveCommissionSplit = commissionToAgent / grossCommission;

  
  const effectiveCommissionSplitDesertNorth = commissionToAgentDesertNorth / grossCommission;


  const handleLevelAgentsChange = (newValue, setLevelAgents) => {
    if (newValue >= 0) {
      setLevelAgents(newValue);
    }
  };



  // Create scroll functions
  const scrollLeft = () => {
    if (scrollableContainerRef.current) {
      scrollableContainerRef.current.scrollBy({
        top: 0,
        left: -200,  // you can customize this value as per your need
        behavior: 'smooth'
      });
    }
  };

const scrollRight = () => {
  if (scrollableContainerRef.current) {
    scrollableContainerRef.current.scrollBy({
      top: 0,
      left: 200,  // you can customize this value as per your need
      behavior: 'smooth'
    });
  }
};

const handleScroll = () => {
  setScrollPosition(scrollableContainerRef.current.scrollLeft);
};

  const levelUnlockThresholds = [0, 0, 3, 5, 10, 15, 20];

  const [isVisible, setIsVisible] = useState(false);

  


  
  const tabs = [
      { name: "Gross Commission Income", 
      results: 
      <><div>
                                <div htmlFor="totalAnual" className='auto-scale-text-med color-white' style={{fontSize:'1.5rem', textAlign:"right", fontWeight:'500'}}>Gross Transaction Commissions:  <span type="text" style={{ fontSize:'2rem', color: "#333", fontWeight:'700', margin:'0 1rem 0'}} id="grossCommission">{formatCurrency(grossCommission)}</span> </div> 

        </div>
        </>,
        content: <>
                <div className='center'>
                  <div style={{ width:'95%'}}> 
                <div className='auto-scale-text-med color-primary' style={{ textAlign:'center', wordWrap: 'normal', paddingTop: "2rem", paddingBottom: "1rem"}}>Gross Commission Income</div>
                                          
                      <div className='auto-scale-text-sm color-secondary' style={{textAlign:'center', wordWrap: 'normal', paddingBottom: "1rem"}}>How much do you currently sell or wish to sell?</div>  
                        
                        <div className='center'>
                        <div htmlFor="transactionQty" className='inputPrompt'>Estimated Number of transactions Per Year: </div>
                        <div style={{ marginBottom:'1.25rem'}}>
                        <input
                          type="number"
                          id="transactionQty"
                          className="calcFormInput"
                          min="0"
                          value={transactionQty}
                          onChange={(e) => {
                            if (e.target.value === '') {
                              setTransactionQty('');
                            } else {
                              setTransactionQty(parseInt(e.target.value) || 0);
                            }
                          }} />
                          </div>
                          
                        
                          
                        <div htmlFor="salePrice" className='inputPrompt' >Average Sale Price Per Transaction: </div>
                        <div style={{ marginBottom:'1.25rem'}}>
                        <input
                          type="number"
                          id="salePrice"
                          className="calcFormInput"
                          min="0"
                          step="25000"
                          placeholder={salePrice}
                          value={salePrice}
                          onChange={(e) => {
                            if (e.target.value === '') {
                              setSalePrice('');
                            } else {
                              setSalePrice(parseFloat(e.target.value) || 0);
                            }
                          }} />
                          
                          </div>

                              <div htmlFor="transactionComp" className='inputPrompt' >Average Commission Percent Per Transaction: </div>
                              <div style={{ marginBottom:'.5rem'}}>

                              <input
                                type="number"
                                id="transactionComp"
                                className="calcFormInput"
                                min="0"
                                step="0.01"
                                value={transactionComp}
                                onChange={(e) => {
                                  if (e.target.value === '') {
                                    setTransactionComp('');
                                  } else {
                                    setTransactionComp(parseFloat(e.target.value) || 0);
                                  }
                                }} />
                                </div>
                      
                    <div className='featured' style={{ textAlign:"center", color:'white'}}>
                        <div className='auto-scale-text-med color-white' style={{ margin:'0 .5rem 0'}}>
                          {formatCurrency(grossCommission)}
                          </div>
                        <div className='auto-scale-text-xs color-white' style={{ fontWeight:'400'}}>
                          Gross Transaction Commission
                          </div>
                    </div>
                    </div>


              </div>
              </div>
        </>
    }, 

    { name: "Brokerage Fees", 
    results: 
    <>
      <div>
                                <div className='auto-scale-text-med color-white' style={{fontSize:'1.5rem', textAlign:"right", fontWeight:'500'}}>Total Fees:  <span type="text" style={{ fontSize:'2rem', color: "#333", fontWeight:'700', margin:'0 1rem 0'}} id="feesPaidToCompany">{formatCurrency(feesPaidToCompany)}</span> </div> 

        </div>
    </>,
    content: 
    <>

                <div className='center' style={{backgroundColor:"white", width:'100%'}}>
                  <div style={{ width:'95%', backgroundColor:'transparent'}}> 

                    <div className='auto-scale-text-med color-primary' style={{ textAlign:'center', wordWrap: 'normal', paddingTop: "2rem", paddingBottom: "1rem"}}>What do you pay your current brokerage?</div>
                    <div className='auto-scale-text-sm color-secondary' style={{textAlign:'center', wordWrap: 'normal', paddingBottom: "1rem"}}>Enter Fees and Commission Details</div>  

                    <div className='center'>
                        <div htmlFor="feeMonthly" className='inputPrompt'>Your Monthly Brokerage Fee: </div>
                        <div style={{ marginBottom:'1.25rem'}}>
                        <input
                          type="number"
                          id="feeMonthly"
                          className="calcFormInput"
                          min="0"
                          step="0.01"
                          value={feeMonthly}
                          onChange={(e) => {
                            if (e.target.value === '') {
                              setFeeMonthly('');
                            } else {
                              setFeeMonthly(parseFloat(e.target.value) || 0);
                            }
                          }} />
                          </div>
                          
                        <div htmlFor="feeTransaction" className='inputPrompt' >Your Per Transaction Filing Fee: </div>
                        <div style={{ marginBottom:'1.25rem'}}>
                        <input
                          type="number"
                          id="feeTransaction"
                          className="calcFormInput"
                          min="0"
                          step="0.01"
                          value={feeTransaction}
                          onChange={(e) => {
                            if (e.target.value === '') {
                              setFeeTransaction('');
                            } else {
                              setFeeTransaction(parseFloat(e.target.value) || 0);
                            }
                          }} />
                          </div>
                          

                            
                        <div style={{ margin:'1rem 0'}}>
                        <div htmlFor="agentCompThem" className='inputPrompt'>Commission Split: </div> 
                        <div style={{ marginBottom:'1.25rem'}}>

                        <input
                          type="number"
                          id="agentCompThem"
                          className="calcFormInput"
                          min="0"
                          step="0.01"
                          value={agentCompThem}
                          onChange={(e) => {
                            if (e.target.value === '') {
                              setAgentCompThem('');
                            } else {
                              setAgentCompThem(parseFloat(e.target.value) || 0);
                            }
                          }} />
                          </div>
                      </div>

                      <div style={{ margin:'1rem 0'}}>
                        <div htmlFor="agentCompThem" className='inputPrompt'>Annual Cap: </div> 
                        <div style={{ marginBottom:'1.25rem'}}>

                        <input
                          type="number"
                          id="compCap"
                          className="calcFormInput"
                          min="0"
                          step="0.01"
                          value={compCap}
                          onChange={(e) => {
                            if (e.target.value === '') {
                              setCompCap('');
                            } else {
                              setCompCap(parseFloat(e.target.value) || 0);
                            }
                          }} />
                          </div>
                      </div>
                      
                      
                      <div className='featured' style={{ textAlign:"center", color:'white'}}>
                        <div className='auto-scale-text-med color-white' style={{ margin:'0 .5rem 0'}}>
                        {formatCurrency(feesPaidToCompany)}
                          </div>
                        <div className='auto-scale-text-xs color-white' style={{ fontWeight:'400'}}>
                        Existing Brokerage Fees
                          </div>
                    </div>

                    </div>
                    </div>

                    </div>



                      
    </>


    },

    { name: "Effective Commission Split", 
    results: 
        <>      <div>
        <div className='auto-scale-text-med color-white' style={{fontSize:'1.5rem', textAlign:"right", fontWeight:'500'}}>Effective Commission Split:  <span type="text" style={{ fontSize:'2rem', color: "#333", fontWeight:'700', margin:'0 1rem 0'}} id="commissionToAgent">{(effectiveCommissionSplit * 100).toFixed(2)}%</span> </div> 

</div></>,
    content: <>
                  <div className='center'> 
                  <div  style={{ width:'80%'}}>
                  

                  
                  <div className='title_secondary' style={{fontSize:'1.5rem', textAlign:'center', wordWrap: 'normal', paddingTop: ".5rem", paddingBottom: "1rem"}}>Based on the information you provided, this is your effective commission split.</div> 
                
                  
                  </div>

                  <div className='featured' style={{fontSize:'1.25rem', textAlign:"center", fontWeight:'500', color:'white'}}>
                        <div style={{ fontSize:'3rem', fontWeight:'700', margin:'0 1rem 0'}}>
                        {(effectiveCommissionSplit * 100).toFixed(2)}%
                          </div>
                        <div>
                          Effective Commission Split
                          </div>
                          <div>
                          At your current brokerage
                          </div>
                    </div>

                  </div>
              </>  
        },  


      

      
    { name: "What about Desert North?",
        results: 
            <><div>
                          <div htmlFor="totalAnual" className='auto-scale-text-med color-secondary' style={{fontSize:'1.75rem', textAlign:"center"}}>Net Commission</div> 
                                  <div>
                                    <div htmlFor="personalCommissionToAgentDesertNorth" className='title_white' style={{fontSize:'1.75rem', textAlign:"center"}}> 
                                    <span type="text" id="personalCommissionToAgentDesertNorth">{formatCurrency(commissionToAgentDesertNorth)}</span><span style={{fontSize:"1rem", color:"#333"}} > </span>
                                    </div>
                                  </div>
              </div></>,
        content: <>
                    <div className='center'> 
                      <div  style={{ width:'70%'}}>
                      <div className='auto-scale-text-med color-primary' style={{ textAlign:'center', wordWrap: 'normal', paddingTop: "2rem", paddingBottom: "1rem"}}>Now let's see how we compare!</div>

                      
                      <div className='auto-scale-text-sm color-secondary' style={{ textAlign:'center', wordWrap: 'normal', paddingTop: ".5rem", paddingBottom: "1rem"}}>We already know about your transactions, so let's move on to our passive income opportunity on the next slide. </div> 
                      
                      
                      </div>
                      </div>
                  </>  
            },  


    { name: "Profit Share Earnings", 
    results: 
    <>
      <div className='auto-scale-text-med color-white' style={{fontSize:'1.5rem', textAlign:"right", fontWeight:'500', marginRight:'1rem'}}>Total Passive Income:  <span type="text" style={{ fontSize:'2rem', color: "#fff", fontWeight:'700', marginLeft:'1rem'}}>{formatCurrency(totalAnual)}</span>/yr <span style={{marginLeft:'1rem'}}></span>  or <span type="text" style={{ fontSize:'2rem', color: "#fff", fontWeight:'700', marginLeft:'1rem'}}>{formatCurrency(totalMonthly)}</span>/mo</div> 

    </>,

    content: <>
          
          <div className='center'> 
                        <div style={{width:'90%', backgroundColor:'transparent'}}>
                        <div className='auto-scale-text-med color-primary' style={{ textAlign:'center', wordWrap: 'normal', paddingTop: "2rem", paddingBottom: "0rem"}}>Passive Income Through Profit Sharing</div>

                          

                          <div className='auto-scale-text-sm color-secondary' style={{ textAlign:'center', wordWrap: 'normal', paddingTop: "0rem"}}>Earn Profit Share checks by recruiting new agent's to Desert North</div>

                          <div className="scrollingContainer">
    <button
      className={`scrollButton left ${scrollPosition === 0 ? 'hide' : ''}`}
      onClick={scrollLeft}
    >
      &lt;
    </button>




                  <div className="levelContainer" ref={scrollableContainerRef} onScroll={handleScroll}>
                      {[1, 2, 3, 4, 5, 6].map((level) => (
                        <div key={`level${level}`} className="levelColumn" style={{ position: "relative" }}>
                          {level !== 1 && level1Agents < levelUnlockThresholds[level] && (
                            <div className="grayOverlay">
                              <div style={{margin:"1rem"}}>
                                <div style={{ fontSize:"2rem", color:"#BCD400"}}>Add {levelUnlockThresholds[level] - level1Agents} more </div>
                                <div style={{ fontSize:"1.5rem", fontWeight:"500", color:"#fff"}}>Level 1 agents to unlock</div>
                              </div>
                            </div>
                          )}
                          <div className="title_secondary" style={{ fontSize: "1.5rem" }}>
                            Level {level}
                          </div>
                          <div className="title_secondary" style={{ fontSize: "1.25rem", paddingBottom: "1rem" }}>
                            <span id={`level${level}AgentsValue`}>{eval(`level${level}Agents`)}</span> Agents
                          </div>
                          <div className="inputWrapper" style={{ fontSize: "1rem", paddingBottom: ".5rem" }}>
                            <button
                              type="button"
                              className="decrementButton"
                              onClick={() =>
                                handleLevelAgentsChange(
                                  eval(`level${level}Agents`) - 1,
                                  eval(`setLevel${level}Agents`)
                                )
                              }
                            >
                              -
                            </button>
                            <button
                              type="button"
                              className="incrementButton"
                              onClick={() =>
                                handleLevelAgentsChange(
                                  eval(`level${level}Agents`) + 1,
                                  eval(`setLevel${level}Agents`)
                                )
                              }
                            >
                              +
                            </button>
                          </div>

                          <div>
                            <span id={`level${level}Anual`} className="outputValueWhite">
                              {`$${eval(`level${level}Anual`).toFixed(2)}`}
                            </span>{" "}
                          </div>
                          <div>per year</div>
                          <div>
                            <span id={`level${level}Monthly`} className="outputValueWhite">
                              {`$${eval(`level${level}Monthly`).toFixed(2)}`}
                            </span>{" "}
                          </div>
                          <div>per month</div>
                        </div>
                      ))}
                    </div>
                    <button
      className={`scrollButton right ${scrollPosition >= (scrollableContainerRef.current?.scrollWidth - scrollableContainerRef.current?.clientWidth) ? 'hide' : ''}`}
      onClick={scrollRight}
    >
      &gt;
    </button>
  </div>

                          <div className='auto-scale-text-med color-primary' style={{fontSize:'1.5rem', textAlign:'center', wordWrap: 'normal', paddingTop: "0rem"}}>How much are your recruits selling?</div>
                          
                          <div style={{position: "relative", marginTop: '1rem'}}>
                          
                          <div className='center'>
                          <label htmlFor="averageAgentSales" style={{position: "absolute", left: "5%", top: '1.5rem'}}>
                            $0.00
                          </label>
                          <label htmlFor="averageAgentSales" style={{position: "absolute", right: "5%", top: '1.5rem'}}>
                            $75,000(+)
                          </label>
                              <input
                                type="range"
                                id="averageAgentSales"
                                min="0"
                                max="100"
                                value={averageAgentSales}
                                onChange={(e) => setAverageAgentSales(e.target.value)}
                              /></div>
                              <label
                              htmlFor="averageAgentSales"
                              style={{
                                fontSize: "1rem",
                                fontWeight: "400",
                                textAlign: "center",
                                wordWrap: "normal",
                                paddingTop: "2.5rem",
                                paddingBottom: "2rem",
                                display: "block",
                                margin: "0 auto"
                              }}
                            >
                              {" "}
                              {averageAgentSales}% Capped
                            </label>
                              </div>
                          
                    </div>






                        </div>

          </>  
    },
      


    { name: "The Bottom Line", 
        results: 
          <>
          <div style={{ display:'flex', flex:'row'}}>
  
          <div className='column' style={{backgroundColor: '#BCD400', flexBasis:'1, 0, 50%'}}>
            <div className='center'>
              <div className='auto-scale-text-lg color-white' style={{ textAlign:"center", fontWeight:'700'}}>{(effectiveCommissionSplitDesertNorth * 100).toFixed(2)}%</div>
              </div>
          </div>
          <div className='column' style={{backgroundColor: '#BCD400', flexBasis:'1, 0, 50%'}}>
            <div className='center'>
              <div className='auto-scale-text-lg color-white' style={{ textAlign:"center", fontWeight:'700'}}>{(effectiveCommissionSplitDesertNorth * 100).toFixed(2)}%</div>
              </div>
          </div>
  
  
  
          </div>
          </>,
          content: 
          <>
                          <div  className='center'>
                              <div style={{ width:'90%'}}>

                              <div className='auto-scale-text-med color-primary' style={{ textAlign:'center', wordWrap: 'normal', paddingTop: "2rem", paddingBottom: "0rem"}}>Side by Side Comparison</div>
                              <div className='auto-scale-text-sm color-secondary' style={{ textAlign:'center', wordWrap: 'normal', paddingTop: ".5rem", paddingBottom: "3rem"}}>Which one would you choose?</div> 



                                <div class="row" style={{backgroundColor:"#fff"}}>
                                  <div class="column" style={{fontWeight:"700", fontSize:'1.5rem'}}>Desert North Realty</div>
                                  <div class="column" style={{fontWeight:"700", fontSize:'1.5rem'}}>Other Brokerage</div>
                                </div>
                                

                                <><><div className="table-row">
                                              <div class="column" style={{ fontWeight: "500", fontSize: '1.25rem' }}>Gross Commission</div>
                                            </div><div className="row" style={{backgroundColor: "#fff", padding: '0rem', margin: '0rem' }}>
                                                <div className="column" style={{  }}><span className="inputResultsPositive" id="grossCommissionDesertNorth">{formatCurrency(grossCommissionDesertNorth)}(+)</span></div>
                                                <div className="column" style={{ backgroundColor: "#fff" }}><span className="inputResultsPositive" id="grossCommission">{formatCurrency(grossCommission)}(+)</span></div>
                                              </div><div className="table-row">
                                                <div class="column" style={{ fontWeight: "500", fontSize: '1.25rem' }}>Passive Income Opportunity</div>
                                              </div><div class="row" style={{backgroundColor: "#fff", padding: '0rem', margin: '0rem' }}>
                                                <div class="column" style={{ backgroundColor: "#fff" }}><span className="inputResultsPositive" id="plusPassiveIncome">{formatCurrency(plusPassiveIncome)}(+)</span></div>
                                                <div class="column" style={{ backgroundColor: "#fff" }}><span className="inputResultsNegative">NONE</span></div>
                                              </div><div className="table-row">
                                                <div class="column" style={{ fontWeight: "500", fontSize: '1.25rem' }}>Profit Share Contribution</div>
                                                <div class="column" style={{ fontWeight: "500", fontSize: '1.25rem' }}>Transaction & Other Fees</div>
                                              </div><div class="row"style={{backgroundColor: "#fff", padding: '0rem', margin: '0rem' }}>
                                                <div class="column"><span className="inputResultsNegative" id="lessProfitShare">{formatCurrency(lessProfitShare)}(-)</span></div>
                                                <div class="column"><span className="inputResultsNegative" id="feesPaidToCompany">{formatCurrency(feesPaidToCompany)}(-)</span></div>
                                              </div><div className="table-row">
                                                <div class="column" style={{ fontWeight: "500", fontSize: '1.25rem' }}>Net Commissions Paid</div>
                                              </div><div class="row" style={{backgroundColor: "#fff", padding: '0rem', margin: '0rem' }}>
                                                <div class="column" style={{ backgroundColor: "#fff" }}><span className="inputResults" id="commissionToAgentDesertNorth">{formatCurrency(commissionToAgentDesertNorth)}</span></div>
                                                <div class="column" style={{ backgroundColor: "#fff" }}><span className="inputResults" id="commissionToAgent">{formatCurrency(commissionToAgent)}</span></div>
                                              </div></><div className="table-row">
                                                <div class="column" style={{ fontWeight: "500", fontSize: '1.25rem' }}>Effective Commission Split</div>
                                              </div></>
                                
                                <div class="row" style={{ backgroundColor: "#fff",padding: '0rem', margin: '0rem' }}>
                                  <div class="column"><span className="inputResultsFinal" id="effectiveCommissionSplitDesertNorth" style={{fontSize:'clamp(5px, 2rem, 50px)'}}>{(effectiveCommissionSplitDesertNorth * 100).toFixed(2)}%</span></div>
                                  <div class="column"><span className="inputResultsFinal" id="effectiveCommissionSplit"  style={{fontSize:'clamp(5px, 2rem, 50px)'}}>{(effectiveCommissionSplit * 100).toFixed(2)}%</span></div>
                                </div>



                              </div>
                              </div>
          </>
          },
  ];
  const tabContainerRef = useRef(null);

  const scrollToTabs = () => {
    console.log('outside if statement');
    if (tabContainerRef.current) {
      
      console.log('inside if statement'); // Add this line
      tabContainerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const nextTab = () => {
    if (currentTab < tabs.length - 1) {
      setCurrentTab(prevTab => prevTab + 1);
    } else if (currentTab === tabs.length - 1) {
      restart();
    }
    scrollToTabs();
  }
  
  const prevTab = () => {
    if (currentTab > 0) {
      setCurrentTab(prevTab => prevTab - 1);
    }
    scrollToTabs();
  }
  
  const restart = () => {
    setCurrentTab(0);
    setAverageAgentSales(100);
    setLevel1Agents(3);
    setLevel2Agents(0);
    setLevel3Agents(0);
    setLevel4Agents(0);
    setLevel5Agents(0);
    setLevel6Agents(0);
    setTransactionQty(0);
    setFeeMonthly(0);
    setFeeTransaction(0);
    setSalePrice(0);
    setTransactionComp(3);
    setAgentCompThem(80);
    setHighestTab(5);
    setScrollPosition(0);
    scrollToTabs();
    // If you want to also reset the scroll position of the scrollable container, use this:
    if (scrollableContainerRef.current) {
      scrollableContainerRef.current.scrollTop = 0;
      scrollableContainerRef.current.scrollLeft = 0;
    }
  }

  const loadCalculator = () => {
    console.log('loadCalculator called'); // Add this line
    setCurrentTab(0);
    setTimeout(() => {
      scrollToTabs();
    }, 0);
  };
  
  




  return (
    <>
      <div className='center' style={{ backgroundColor: '#f8f8f8'}}>
      <div className="income-simulation-container">
      {currentTab === null ? 
        <div className="start-screen">
                <div className='flex' style={{ width: '80%', backgroundColor: 'transparent' }}>
        <div className='auto-scale-text-lg color-primary' style={{ textAlign: 'left', width: '100%' }}>INCOME COMPARISON TOOL</div>
        <div className='auto-scale-text-med color-secondary ' style={{ textAlign: 'left', width: '100%' }}>COMPARE US AGAINST YOUR CURRENT BROKERAGE</div>
        <Divider color='#BCD400' width='90px' margin='30' alignment='left' />

        <div className='text-content color-secondary' style={{ textAlign: 'left', width: '100%', paddingBottom:'1rem' }}>Even though our culture is second to none, it boils down to the dollars and cents. For an “apples to apples” comparison, spend some time with the comparison calculator and determine if the math works in your favor at your current brokerage.</div>
        <button className='dnr_button' 
           onClick={() => loadCalculator()}
            >Start Comparison Calculator</button>




      </div>
          
          
        </div>
      : 
        <div className="income-simulation">



          <div ref={tabContainerRef} className="contentPane">
          {tabs[currentTab].content}
          </div>

        <div className='income_footer'>        

    <div className='center'  style={{marginTop:'0%', paddingTop:'0%', width:'100%', backgroundColor:'#BCD400'}}>



    <div className='row' style={{ height:'100%', width:'100%', backgroundColor:'#BCD400'}}>
          <div className='column'>
              {currentTab > 0 && 
              <button className='prev_tab_button' 
              style={{
                color: "#fff",
                backgroundColor: "#BCD400",
                width: '100%',
                height: '100%',
                borderRadius: '0',
                fontSize: '1.25rem',
                lineHeight: '1.25',
            }}
              onClick={prevTab}><span style={{fontSize:'1.75rem', padding:'0', margin:'0'}}>&#8249;</span> {tabs[currentTab - 1].name}
              </button>}
          </div>
          <div className='column'>
              {currentTab < tabs.length - 1 ? 
                <button className='tab_button' 
                style={{
                  color: "#fff",
                  backgroundColor: "#BCD400",
                  width: '100%',
                  height: '100%',
                  borderRadius: '0',
                  fontSize: '1.25rem',
                  lineHeight: '1.25',
              }}
                onClick={nextTab}>{tabs[currentTab + 1].name} <span style={{fontSize:'1.75rem', padding:'0', margin:'0'}}>&#8250;</span></button>
              : 
                <button className='tab_button' 
                style={{
                  color: "#fff",
                  backgroundColor: "#BCD400",
                  width: '100%',
                  height: '100%',
                  borderRadius: '0',
                  fontSize: '1.25rem',
                  lineHeight: '1.25',
              }}
                onClick={restart}>Restart <span style={{fontSize:'1.75rem', padding:'0', margin:'0'}}>&#8250;</span></button>
              }
          </div>
        </div>
    </div>




        </div>
          
   

        </div>

      }
    </div>

    </div>



      </>
    


  );
};

export default AverageAgentCommission;
